const DELAY_MS = 250
const MIN_DURATION_MS = 250

export class LoadingAnimationState {
	active: boolean = $state(false)
	private showAt: number = 0
	private startTimer: ReturnType<typeof setTimeout> | null = null
	private stopTimer: ReturnType<typeof setTimeout> | null = null
	private pending = false

	/** Show animation after 250ms delay. */
	start() {
		this.clearTimers()
		this.pending = true
		this.startTimer = setTimeout(() => {
			this.startTimer = null
			this.active = true
			this.showAt = Date.now()
		}, DELAY_MS)
	}

	/** Stop animation, but ensure it was visible for at least 250ms. */
	stop() {
		this.pending = false
		if (this.startTimer) {
			clearTimeout(this.startTimer)
			this.startTimer = null
			return
		}
		if (!this.active) return

		const elapsed = Date.now() - this.showAt
		const remaining = MIN_DURATION_MS - elapsed

		if (remaining <= 0) {
			this.active = false
		} else {
			if (this.stopTimer) clearTimeout(this.stopTimer)
			this.stopTimer = setTimeout(() => {
				this.stopTimer = null
				this.active = false
			}, remaining)
		}
	}

	/** Stop animation immediately, no minimum duration. */
	cancel() {
		this.pending = false
		this.clearTimers()
		this.active = false
	}

	destroy() {
		this.cancel()
	}

	private clearTimers() {
		if (this.startTimer) {
			clearTimeout(this.startTimer)
			this.startTimer = null
		}
		if (this.stopTimer) {
			clearTimeout(this.stopTimer)
			this.stopTimer = null
		}
	}
}
